<template>
	<div>
		<van-cell title="切换站点" :value="city" @click="showCities()"></van-cell>
		<!-- 选择城市站点 -->
		<Subsite ref="subsite" :siteDetail="city" @onSelected="selectCity"></Subsite>
	</div>
</template>

<script>
	import {mapState,mapMutations} from 'vuex';
	export default{
		computed: {
			...mapState(['site']),
		},
		data(){
			return{
				city:'',
			}
		},
		created() {
			this.loadData();
		},
		methods:{
			selectCity(val) {
				this.city=val[1];
				this.bindPickerChange(val[1]);
			},
			showCities() {
				this.$refs.subsite.show();
			},
			bindPickerChange(value){
				const that=this;
				try {
					this.$axios.get('user/change?site='+value).then(res => {
						let data = res.data;
						if (data.code == 200) {
							this.$store.commit('ChangeSite', value);
							this.$toast('站点成功切换为'+value);
							setTimeout(function() {
								that.$router.replace({path: '/'})
							}, 1000);
							this.showChangeSite = false;
						}else{
							this.$toast.fail(data.msg)
						}
					});
				} catch (e) {
					if (this.$mConfig.debug) {
						console.log(e);
					};
				};
				
			},
			 loadData(){
					try {
						this.$axios.get('user/info').then(res => {
							let data = res.data;
							if (data.code == 200) {
								this.city = data.data.site;
							}
						});
					} catch (e) {
						if (this.$mConfig.debug) {
							console.log(e);
						};
					};
					
							
			},
		}
	}
</script>

<style>
</style>
